import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cx } from '@/utils/cx';
import { Icon, type IconName } from '@/design-system/icons/Icon';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconName;
  label: string;
  size?: number;
};

export const IconButton = forwardRef<HTMLButtonElement, Props>(
  ({ icon, label, size = 19, className, ...rest }, ref) => (
    <button
      ref={ref}
      type={rest.type ?? 'button'}
      aria-label={label}
      title={label}
      className={cx('icon-btn', className)}
      {...rest}
    >
      <Icon name={icon} size={size} />
    </button>
  ),
);
IconButton.displayName = 'IconButton';
